<script lang="ts">
	import { Label, CircleAvatar, type LabelPropsTypes } from '@Shelly/shelly-design-system';

	export let labelProps: {
		size: LabelPropsTypes['size'];
		value: LabelPropsTypes['value'];
		type?: LabelPropsTypes['type'];
		icon?: LabelPropsTypes['icon'];
	} = null;

	export let circleAvatarProps: {
		size: string;
		icon: string;
	} = null;
</script>

<div class="d-flex">
	{#if labelProps?.value && labelProps?.size}
		<Label
			size={labelProps.size}
			type={labelProps?.type}
			value={labelProps?.value}
			icon={labelProps?.icon}
		/>
	{/if}

	{#if circleAvatarProps?.size && circleAvatarProps?.icon}
		<CircleAvatar size={circleAvatarProps.size} icon={circleAvatarProps?.icon} />
	{/if}
</div>
